import { cva } from '@/styled-system/css';

export const tableCellSharedRecipe = cva({
  base: {
    'backgroundColor': 'Table.Cell.bg.default',
    'color': 'Table.Cell.text.default',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease',
    },

    '& [data-c11n-component="Checkbox"]': {
      verticalAlign: 'text-top',
    },

    '& [data-c11n-component="Radio"]': {
      verticalAlign: 'text-top',
    },
  },
  variants: {
    align: {
      left: { textAlign: 'left' },
      center: { textAlign: 'center' },
      right: { textAlign: 'right' },
      start: { textAlign: 'start' },
      end: { textAlign: 'end' },
    },
    appearance: {
      bare: {},
      horizontal: {},
      grid: {
        borderInlineEndWidth: 'Table.Cell',
        borderInlineEndStyle: 'solid',
        borderInlineEndColor: 'Table.Cell.border',
        borderBlockEndWidth: 'Table.Cell',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'Table.Cell.border',
      },
      zebra: {
        '[data-c11n-component="Table.Row"]:nth-child(2n) &': {
          backgroundColor: 'Table.Cell.bg.zebra',
        },
      },
    },
    size: {
      sm: {
        paddingBlock: 'Table.Cell.padding.size.sm.vert',
        paddingInline: 'Table.Cell.padding.size.sm.horz',
      },
      md: {
        paddingBlock: 'Table.Cell.padding.size.md.vert',
        paddingInline: 'Table.Cell.padding.size.md.horz',
      },
      lg: {
        paddingBlock: 'Table.Cell.padding.size.lg.vert',
        paddingInline: 'Table.Cell.padding.size.lg.horz',
      },
    },
  },
  compoundVariants: [
    {
      appearance: ['horizontal', 'zebra'],
      css: {
        borderBlockEndWidth: 'Table.Cell',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'Table.Cell.border',
      },
    },
  ],
});
